export default __webpack_public_path__ + "static/media/X3.837425c5.svg";